import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import { Collapse } from "react-bootstrap";
import { Switch } from "../../../../../Components/CardsPages/Forms/Switch";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import {
    MotivoNaoProcedenciaController,
    SolicitacaoNaoProcedenteController,
} from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useToggle from "../../../../../hooks/useToggle";
import { ISolicitacaoNaoProcedenteAvaliar } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/SolicitacaoNaoProcedente/SolicitacaoNaoProcedente";
import ManutencaoECustos from "../ExecucaoManutencaoConcluida/ManuntecaoECustos";

interface IManutencaoConcluidaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function FinalizarSolicitacao(props: IManutencaoConcluidaProps) {
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const [visivel, setVisivel] = useToggle(false);

    const { execute: executarFormSolicitacaoNaoProcedente, loading } =
        useAsyncCallback(SolicitacaoNaoProcedenteController);

    const handleFinalizarSolicitacaoFormSubmit = (
        formData: ISolicitacaoNaoProcedenteAvaliar
    ) => {
        executarFormSolicitacaoNaoProcedente("FinalizarSolicitacao", {
            ...formData,
            DadosCustos: { ...formData.DadosCustos, ID_CASO },
        })
            .then(() => {
                updateAtendimento();
                ReloadHistorico();
            })
            .then(() => {
                props.setShow(false);
            });
    };

    const { execute: listarMotivosNaoProcedencia } = useAsyncCallback(
        () => MotivoNaoProcedenciaController(ID_CASO),
        [ID_CASO]
    );

    return (
        <div>
            <UnForm handleSubmit={handleFinalizarSolicitacaoFormSubmit}>
                <div className="mb-8">
                    <div className="row m-0 ">
                        {Atendimento ? (
                            <UnForm.LazySelect
                                registerOptions={{
                                    required:
                                        "Quando um atendimento é classificado como não procedente, é obrigatório informar o motivo de não procedência",
                                }}
                                controller={listarMotivosNaoProcedencia}
                                label="Motivo de Não Procedência"
                                name="idMotivo"
                                className={`form-control placeholder-dark-50`}
                                wrapperClassName="col-12 col-md-12 m-0"
                                getDS={(p) => p.DS_MOTIVO_NAO_PROCEDENCIA}
                                getKeyValue={(p) => p.ID_MOTIVO_NAO_PROCEDENCIA}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        ) : null}
                    </div>
                </div>

                <div className="mb-8">
                    <div className="row m-0 ">
                        <UnForm.Textarea
                            registerOptions={{
                                required:
                                    "Quando um atendimento é classificado como não procedente, é obrigatório informar a justificativa.",
                            }}
                            //adaptar o name para nome certo
                            name="DescricaoMotivo"
                            label="Descrição"
                            noRezise
                            rows={4}
                            wrapperClassName="col-12 col-md-12 m-0"
                        />
                    </div>
                </div>

                <Switch
                    label="Existem Custos do Reparo?"
                    color="primary"
                    type="checkbox"
                    onChange={setVisivel}
                    labelPosition="top"
                />

                <Collapse in={visivel} mountOnEnter unmountOnExit>
                    <ManutencaoECustos preInputName="DadosCustos." />
                </Collapse>

                <UnForm.SubmitButton
                    color="success"
                    wrapperClassName="w-100 mt-8"
                    className="w-100"
                    icon={faTimes}
                    loading={loading}
                    disabled={loading}
                    loadingSize={"sm"}
                >
                    Finalizar Solicitação
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}
